import { render, staticRenderFns } from "./image_upload_name_card.vue?vue&type=template&id=0d6e3cc4&scoped=true&lang=pug"
import script from "./image_upload_name_card.vue?vue&type=script&lang=js"
export * from "./image_upload_name_card.vue?vue&type=script&lang=js"
import style0 from "./image_upload_name_card.vue.css?vue&type=style&index=0&id=0d6e3cc4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e3cc4",
  null
  
)

export default component.exports